// extracted by mini-css-extract-plugin
export default {"menuItem":"BaseOverlayMenuListItemPhase2-9_menuItem_Qbw_k","menuItemLink":"BaseOverlayMenuListItemPhase2-9_menuItemLink_mH_of"};